import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress console errors for network requests that we've already handled offline
const originalError = console.error;
console.error = function(...args) {
  const errorStr = args[0]?.toString() || '';
  
  // Suppress XMLHttpRequest/Network errors we've already handled
  if (errorStr.includes('ERR_INTERNET_DISCONNECTED') || 
      errorStr.includes('net::ERR_INTERNET_DISCONNECTED') ||
      (args[1]?.status === 0 && errorStr.includes('POST'))) {
    // These errors are already being handled by our offline system
    // Don't log them to console to avoid spam
    return;
  }
  
  // Call original error handler for all other errors
  originalError.apply(console, args);
};

// Also intercept window error events for XHR errors
window.addEventListener('error', (event) => {
  if (event.message?.includes('ERR_INTERNET_DISCONNECTED') ||
      event.message?.includes('net::ERR_INTERNET_DISCONNECTED')) {
    // Already handled by offline system
    event.preventDefault();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Register Service Worker for offline support and attendance sync
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[Service Worker] Registered successfully:', registration);
        
        // Listen for messages from service worker
        navigator.serviceWorker.addEventListener('message', (event) => {
          const { type, message } = event.data;
          
          if (type === 'ATTENDANCE_SYNCED') {
            console.log('[App] Attendance synced:', message);
          } else if (type === 'SYNC_COMPLETE') {
            console.log(`[App] Sync complete: ${event.data.synced}/${event.data.total} records synced`);
          }
        });
      })
      .catch((error) => {
        console.error('[Service Worker] Registration failed:', error);
      });
  });
}